import styled from "styled-components";
import { theme } from "../../../../../global";

export const JudgesWrapper = styled.div`
  display: block;
  text-align: left;
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const JudgesTitleWrapper = styled.span`
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 600;
  color: ${theme.colors.secondaryText};
  display: inline;
`;

export const JudgesNameWrapper = styled.span`
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.secondaryText};
  display: inline;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;
